
import { Component, Prop, Watch } from "vue-property-decorator"
import { BaseApp } from "~/core/Base"
import { ISidebarItemState } from "~/store/types"
import AppRepository from "~/repositories/AppRepository"
import PlatformSelection from "~/components/PlatformSelection.vue"
import { availableThemes } from "~/constants/theme"
import PermissionHelper from "~/utils/PermissionHelper"
import { MenuMarketing } from "~/constants/menuMarketing"
import { MenuEcom } from "~/constants/menuEcom"
import { MenuCoupon } from "~/constants/menuCoupon"
import { MenuAutopilot } from "~/constants/menuAutopilot"
import { _get, _set } from "~/utils/lodash"
import cloneDeep from "lodash/cloneDeep"
import { Core } from "~/core/Core"
import { MenuTree, MenuItem } from "~/types/menu"
import { menu } from "~/constants/menu"
import * as jdenticon from "jdenticon"

@Component({
  components: {
    PlatformSelection,
  },
})
export default class Header extends BaseApp {
  @Prop({ default: false }) readonly hideSidebar!: boolean
  @Prop({ default: false }) readonly hidePlatformMenu!: boolean

  selectPlatform = false
  isMini = false
  expandItems: Record<string, MenuItem> = {}

  app = new AppRepository(this as any)

  adminName = ""
  avartarSVG = ""
  adminEmail = ""

  @Watch("isMini")
  onSearch(newValue) {
    this.$emit("onMenuExpandedChanged", !newValue)
  }

  themeBZB() {
    if (Core.config.MARKETING_THEME == "BZB") {
      return true
    }
    return false
  }

  changeThemeColor() {
    if (this.themeBZB()) {
      return "black--text"
    }

    return "primary--text"
  }

  changeThemeLogo() {
    if (this.themeBZB()) {
      return "/images/logo-bzb.png"
    }

    return "/images/logo-profile-no-text.png"
  }

  changeStyleThemeLogo() {
    if (this.themeBZB()) {
      return "height: 42px;"
    }

    return "height: 36px; margin-top: -4px"
  }

  get changeUIThemeMenuLogo(): boolean {
    if (this.themeBZB()) {
      return true
    }

    return false
  }

  expandMenu(item) {
    this.expandItems = item
  }

  onNavMouseEnter() {
    if (!this.themeBZB()) {
      return
    }
    this.isMini = false
  }

  onNavMouseLeave() {
    if (!this.themeBZB()) {
      return
    }
    this.isMini = true
  }

  closeExpand() {
    this.expandItems = {}
  }

  expandMenuRoute(to: string = "") {
    this.expandItems = {}
    this.$refs.navbar.isMouseover = false
    if (to) {
      this.$router.push(to)
    }
  }

  onExpandMenuItemClick() {
    this.expandItems = {}
    this.$refs.navbar.isMouseover = false
  }

  getMenuItemRouterTo(item: MenuItem) {
    if (item.target || item.href) {
      return undefined
    }
    return item.to
  }

  getMenuItemHref(item: MenuItem) {
    if (item.href) {
      return item.href
    }
    if (item.target === "_blank" && item.to) {
      return this.$router.resolve(item.to).href
    }
    return undefined
  }

  set title(value) {
    this.$app.saveToState("doc", {
      platformName: value,
    })
  }

  set platform(value) {
    this.$app.saveToState("doc", {
      platform: value,
    })
  }

  get calculatePositionPlatform(): number {
    return 350 * (availableThemes().length / 3)
  }

  get title() {
    return this.$app.state.app.doc.platformName
  }

  get platform() {
    return this.$app.state.app.doc.platform
  }

  @Watch("app.state.app.theme.name")
  onPlatformNameChange(value: any, oldValue: any) {
    this.title = value
  }

  @Watch("app.state.app.theme.alias")
  onPlatformChange(value: any, oldValue: any) {
    this.platform = value
  }

  createPermisionMap(parmission: string[]) {
    // Loop through main menu for validate permission in new menu
    return parmission.reduce((accumulate, perm) => {
      if (!perm) {
        return accumulate
      }
      const keys = perm.split("_")
      const feature = keys[1] ?? ""
      const menu = keys[2] ?? ""

      if (!feature || !menu) {
        return accumulate
      }

      accumulate[feature + "_" + menu] = true
      return accumulate
    }, {} as Record<string, boolean>)
  }

  isHaveMenuPermission(
    permissionMap: Record<string, boolean>,
    menuPermissionKey?: string
  ): boolean {
    if (!menuPermissionKey) {
      return true
    }
    return permissionMap[menuPermissionKey]
  }

  filterMenuWithPermission(
    menus: Record<string, MenuItem> | undefined,
    permissionMap: Record<string, boolean>
  ) {
    if (!menus || Object.keys(menus).length === 0) {
      return {}
    }

    let filredMenus = {}

    for (let i in menus) {
      const subMenuItem = menus[i]
      const permissionKey = subMenuItem.permission_key
      if (
        !subMenuItem.isHide &&
        this.isHaveMenuPermission(permissionMap, permissionKey)
      ) {
        filredMenus[i] = subMenuItem
      }
    }
    return filredMenus
  }

  getSideBar() {
    const platform = this.platform ?? ""
    if (!platform) {
      return []
    }

    const menuMap: Record<string, MenuTree> = {
      marketing: MenuMarketing,
      ecom: MenuEcom,
      coupon: MenuCoupon,
      autopilot: MenuAutopilot,
    }

    const rawMenuObj = menuMap[platform]
    if (!rawMenuObj) {
      return []
    }

    let menuObj: MenuTree = {}
    const permissionMap = this.createPermisionMap(this.$auth.sidebarPermission)

    for (const mainMenuKey in rawMenuObj) {
      const mainMenuItem = rawMenuObj[mainMenuKey]
      if (mainMenuItem.isHide) {
        continue
      }

      let newMainMenu = cloneDeep(mainMenuItem)

      let expandMenus = this.filterMenuWithPermission(
        mainMenuItem.expands,
        permissionMap
      )

      let childrenMenu = this.filterMenuWithPermission(
        mainMenuItem.children,
        permissionMap
      )

      newMainMenu.expands = expandMenus
      newMainMenu.children = childrenMenu

      if (mainMenuItem.permission_key) {
        if (
          this.isHaveMenuPermission(permissionMap, mainMenuItem.permission_key)
        ) {
          menuObj[mainMenuKey] = newMainMenu
        }
      } else {
        if (newMainMenu.isChild) {
          if (
            Object.keys(childrenMenu).length > 0 ||
            Object.keys(expandMenus).length > 0
          ) {
            menuObj[mainMenuKey] = newMainMenu
          }
        } else {
          menuObj[mainMenuKey] = newMainMenu
        }
      }
    }

    let menuArray: MenuItem[] = []
    for (let i in menuObj) {
      const mainMenuItem = menuObj[i]
      menuArray.push(mainMenuItem)
    }
    const sorted = menuArray.sort((a, b) => {
      return (a.order ?? 9999) - (b.order ?? 9999)
    })

    return sorted
  }

  onClickLogout() {
    this.$auth.logout(this, false)
  }

  mounted() {
    this.title = this.$app.state.app.theme?.name
    this.platform = this.$app.state.app.theme?.alias
    this.isMini = this.themeBZB()

    this.adminName = this.$app.state.app.me?.first_name || ""
    this.adminEmail = this.$app.state.app.me?.email || ""
    this.avartarSVG = jdenticon.toSvg(this.adminEmail, 35)

    this.$nextTick(() => {
      this.$emit("onMenuExpandedChanged", !this.isMini)
    })
  }

  onUpdateProfile() {
    let userID = this.$app.state.app.me?.user_id
    this.$router.push({
      path: `/marketing/users/${userID}/edit`,
    })
  }
}
